import { environment } from '@environments/environment';

/** Production builds still allow diagnostics when served on this machine. */
export function shouldLogBackend(environment: string, hostname: string): boolean {
  return environment !== 'production' || hostname === 'localhost' ||
    hostname === '127.0.0.1' || hostname === '[::1]' || hostname === '::1' ||
    hostname.endsWith('.localhost');
}

export const SERVER_DEBUG_LOG_ENABLED = shouldLogBackend(
  environment.env,
  typeof window === 'undefined' ? '' : window.location.hostname,
);
